import React,{ useContext } from 'react';
import Marquee from "react-fast-marquee";

import './Skills.css'

import { ThemeContext } from '../../contexts/ThemeContext';
import { skillsData, skillsData2 } from '../../data/skillsData'
import { skillsImage } from '../../utils/skillsImage'

import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import { AiOutlineHome } from "react-icons/ai";
import { NavHashLink as NavLink } from 'react-router-hash-link';
function Skills() {

    const { theme } = useContext(ThemeContext);
    const skillBoxStyle = {
        backgroundColor: theme.secondary,
        boxShadow: `0px 0px 30px ${theme.primary30}`
    }


    const useStyles = makeStyles((t) => ({
        search : {
            color: theme.tertiary, 
            width: '40%',
            height: '2.75rem',
            outline: 'none',
            border: 'none',
            borderRadius: '20px',
            padding: '0.95rem 1rem',
            fontFamily: "'Noto Sans TC', sans-serif",
            fontWeight: 500,
            fontSize: '0.9rem',  
            backgroundColor: theme.secondary, 
            boxShadow: theme.type === 'dark' ? 'inset 3px 3px 6px #ffffff10, inset -3px -3px 6px #00000060' : 'inset 3px 3px 6px #ffffffbd, inset -3px -3px 6px #00000030',
            "&::placeholder": {
                color: theme.tertiary80, 
            },
            [t.breakpoints.down('sm')]: {
                width:'350px',
            },
        },
        home: {
            color: theme.secondary,
            position: 'absolute',
            top: 25,
            left: 25,
            padding: '7px',
            borderRadius: '50%',
            boxSizing: 'content-box',
            fontSize: '2rem',
            cursor: 'pointer',
            boxShadow: theme.type === 'dark' ? '3px 3px 6px #ffffff40, -3px -3px 6px #00000050' : '3px 3px 6px #ffffff40, -3px -3px 6px #00000050',
            transition: 'all 0.3s ease-in-out',
            "&:hover": 
            {
                color: theme.tertiary,
                transform: 'scale(1.1)',
            },
            [t.breakpoints.down('sm')]: {
                fontSize: '1.8rem',
            },
        },
    }));

    const classes = useStyles();

    return (
        <div className="skills" style={{backgroundColor: theme.secondary}}>
            <div className="skillsHeader">
                
                {/* <NavLink
                                to='/#skills'
                                smooth={true}
                                spy='true'
                                duration={2000}
                            > */}
                <h2 style={{color: theme.primary}}>Skills</h2>
                {/* </NavLink> */}
            </div>
            <div className="skillsContainer">
                <div className="skill--scroll">
                <h5 style={{color:theme.tertiary, fontFamily:"monospace" , textAlign:"center", fontSize:"20px"}}>Frontend</h5>
                    <Marquee 
                        gradient={false} 
                        speed={80} 
                        pauseOnHover={true}
                        pauseOnClick={true} 
                        delay={0}
                        play={true} 
                        direction="left"
                    >
                        {skillsData.map((skill, id) => (
                                <div className="skill--box" key={id} style={skillBoxStyle}>
                                    <img src={skillsImage(skill)} alt={skill} />
                                    <h3 style={{color: theme.tertiary}}>
                                        {skill}
                                    </h3>
                                </div>
                        ))}
                        
                    </Marquee>
                    <h5 style={{color:theme.tertiary, fontFamily:"monospace" , textAlign:"center", fontSize:"20px"}}>Backend</h5>
                    <div 
                        // gradient={false} 
                        // speed={80} 
                        // pauseOnHover={true}
                        // pauseOnClick={true} 
                        // delay={20}
                        // play={true} 
                        // direction="left"
                        className='backendSkills'
                    >
                        {skillsData2.map((skill, id) => (
                            <div className="skill--box1" key={id} style={skillBoxStyle}>
                                <img src={skillsImage(skill)} alt={skill} />
                                <h3 style={{color: theme.tertiary}}>
                                    {skill}
                                </h3>
                            </div>
                        ))}
                        
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Skills
